export default __webpack_public_path__ + "static/media/benefits-of-living-in-an-exclusive-3-BHK-community.7afc0fad.png";